module.exports = __webpack_public_path__ + "img/w7-b2.4102b70c.jpg";